import { put, select } from 'redux-saga/effects';
import { signalingPhoneUsersJoined } from 'features/sip/actions';
import { activeUserCountUpdated, selectToolbarUserCount } from 'features/toolbar/toolbarSlice';

export function* onSipUsersJoinedForCountSaga(
  action: ReturnType<typeof signalingPhoneUsersJoined>
) {
  const { users } = action.payload;

  const currentCount: number = yield select(selectToolbarUserCount);
  yield put(activeUserCountUpdated(currentCount + users.length));
}
